import { c as _c } from "react/compiler-runtime";
import type { ReviewCreditCardsPage } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import type { Review } from 'schema-dts';
import { LinkedDataJson } from 'src/shared/seo/LinkedDataJson';
import { getReviewSchema } from './utils';
export function ReviewsLinkedData(t0) {
  const $ = _c(5);
  const {
    review,
    id
  } = t0;
  let t1;
  if ($[0] !== review) {
    t1 = getReviewSchema(review);
    $[0] = review;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id || $[3] !== t1) {
    t2 = <LinkedDataJson id={id} schema={t1} />;
    $[2] = id;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}